module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-table', {
    attrs: {
      "api-mode": false,
      "fields": _vm.tableFields,
      "data": _vm.rowData.lines,
      "noDataTemplate": "No se encontraron resultados"
    },
    scopedSlots: _vm._u([{
      key: "percentageFromTotal",
      fn: function(props) {
        return [_c('div', {
          staticClass: "progressContainer text-center"
        }, [_c('div', {
          staticClass: "progressBar"
        }, [_c('div', {
          style: ('font-size: 14px;margin:-5px 10px;float:left')
        }, [_vm._v(_vm._s(_vm.formatPercentage(props.rowData.percentageFromTotal)))]), _vm._v(" "), (_vm.window.width > 620) ? _c('div', {
          staticClass: "progress table-bar"
        }, [_c('div', {
          class: 'progress-bar progress-bar-' + _vm.formatProgress(props.rowData.percentageFromTotal),
          style: ('width:' + _vm.formatPercentage(props.rowData.percentageFromTotal)),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })]) : _vm._e()])])]
      }
    }, {
      key: "quantity",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.rowData.quantity))), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.minimumStockUnit))])])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fcf40ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/InventoryProductStatusLine.vue
// module id = 497
// module chunks = 1